import { createSlice } from "@reduxjs/toolkit";
import { readFromSessionStorage, saveToSessionStorage } from "utils/helper";

const initialState = {
  data: (() => {
    const storedData = readFromSessionStorage("occupantOption");
    return Array.isArray(storedData) ? storedData : [];
  })(),
  isFetching: false,
  isOccupantSet: false,
  error: "",
};

export const occupantOption = createSlice({
  name: "occupantOption",
  initialState,
  reducers: {
    setOccupantBegin: (state) => {
      state.isFetching = true;
      state.data = [];
      state.error = "";
    },

    setOccupantSuccess: (state, action) => {
      const { newData } = action.payload;
      state.isFetching = false;
      state.data = newData;
      saveToSessionStorage("occupantOption", newData);
    },

    setOccupantError: (state, action) => {
      state.isFetching = false;
      sessionStorage.removeItem("occupantOption");
      state.data = [];
      state.error = action.payload;
    },

    resetState: (state) => {
      return initialState;
    },
  },
});

export const { setOccupantBegin, setOccupantSuccess, setOccupantError } =
  occupantOption.actions;

export const currentOccupantSelector = (state) => state.occupantOption.data;

export default occupantOption.reducer;
